import type { AssetSubSector } from '../types/valuation';

export const generateAssetSectors = (): AssetSubSector[] => [
  {
    "id": 1,
    "name": "Passion Investments",
    "sectorId": 1
  },
  {
    "id": 2,
    "name": "Energy",
    "sectorId": 2
  },
  {
    "id": 3,
    "name": "Materials",
    "sectorId": 2
  },
  {
    "id": 4,
    "name": "Industrials",
    "sectorId": 2
  },
  {
    "id": 5,
    "name": "Consumer Discretionary",
    "sectorId": 2
  },
  {
    "id": 6,
    "name": "Consumer Staples",
    "sectorId": 2
  },
  {
    "id": 7,
    "name": "Health Care",
    "sectorId": 2
  },
  {
    "id": 8,
    "name": "Financials",
    "sectorId": 2
  },
  {
    "id": 9,
    "name": "Information Technology",
    "sectorId": 2
  },
  {
    "id": 10,
    "name": "Communication Services",
    "sectorId": 2
  },
  {
    "id": 11,
    "name": "Utilities",
    "sectorId": 2
  },
  {
    "id": 12,
    "name": "Real Estate",
    "sectorId": 2
  },
  {
    "id": 13,
    "name": "Equity Other",
    "sectorId": 2
  },
  {
    "id": 14,
    "name": "Corporate Bonds",
    "sectorId": 3
  },
  {
    "id": 15,
    "name": "Government Bonds",
    "sectorId": 3
  },
  {
    "id": 16,
    "name": "Managed Funds",
    "sectorId": 3
  },
  {
    "id": 17,
    "name": "Fixed/Term Deposits",
    "sectorId": 3
  },
  {
    "id": 18,
    "name": "Fixed Income (Other)",
    "sectorId": 3
  },
  {
    "id": 19,
    "name": "Cash at Call",
    "sectorId": 4
  },
  {
    "id": 20,
    "name": "Cash Equivalents",
    "sectorId": 4
  },
  {
    "id": 21,
    "name": "Bank Loan",
    "sectorId": 4
  },
  {
    "id": 22,
    "name": "Residential Property",
    "sectorId": 5
  },
  {
    "id": 23,
    "name": "Commercial Property",
    "sectorId": 5
  },
  {
    "id": 24,
    "name": "Listed Property Trusts",
    "sectorId": 5
  },
  {
    "id": 25,
    "name": "Managed Funds",
    "sectorId": 5
  },
  {
    "id": 26,
    "name": "Diversified Managed Funds",
    "sectorId": 6
  },
  {
    "id": 27,
    "name": "Diversified ETFs",
    "sectorId": 6
  },
  {
    "id": 28,
    "name": "Cryptocurrency",
    "sectorId": 7
  },
  {
    "id": 29,
    "name": "Metals",
    "sectorId": 8
  },
  {
    "id": 30,
    "name": "Agricultural",
    "sectorId": 8
  },
  {
    "id": 31,
    "name": "Energy",
    "sectorId": 8
  },
  {
    "id": 32,
    "name": "Other",
    "sectorId": 9
  },
  {
    "id": 33,
    "name": "Plant and Equipment",
    "sectorId": 10
  },
  {
    "id": 34,
    "name": "Rural Property",
    "sectorId": 5
  },
  {
    "id": 35,
    "name": "Investment Grade Bonds",
    "sectorId": 3
  },
  {
    "id": 36,
    "name": "High Yield Bonds",
    "sectorId": 3
  },
  {
    "id": 37,
    "name": "Emerging Market Bonds",
    "sectorId": 3
  },
  {
    "id": 38,
    "name": "Private Credit",
    "sectorId": 3
  },
  {
    "id": 39,
    "name": "Office Property",
    "sectorId": 5
  },
  {
    "id": 40,
    "name": "Infrastructure",
    "sectorId": 5
  },
  {
    "id": 41,
    "name": "Development",
    "sectorId": 5
  },
  {
    "id": 42,
    "name": "Private Equity",
    "sectorId": 11
  },
  {
    "id": 43,
    "name": "Venture Capital",
    "sectorId": 11
  },
  {
    "id": 44,
    "name": "Distressed Credit",
    "sectorId": 11
  },
  {
    "id": 45,
    "name": "Hedge Fund",
    "sectorId": 11
  },
  {
    "id": 46,
    "name": "Property Fund",
    "sectorId": 11
  },
  {
    "id": 47,
    "name": "Private Company",
    "sectorId": 11
  },
  {
    "id": 48,
    "name": "Private Debt",
    "sectorId": 11
  }
];